import React from 'react';
import PropTypes from 'prop-types';
import { Input, mergeClasses } from '@fluentui/react-components';
import { SearchRegular } from '@fluentui/react-icons';
import { useScopeSelectorStyles } from '../styles';

const SearchBox = ({ placeholder, onSearchChange }) => {
  const styles = useScopeSelectorStyles();

  return (
    <div className={mergeClasses('scope-selector-search', styles.scopeSearch)}>
      <Input
        contentBefore={<SearchRegular />}
        placeholder={placeholder}
        onChange={onSearchChange}
      />
    </div>
  );
};

SearchBox.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export { SearchBox };
